import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { actionTypes } from '../modules/Auth/_redux/authRedux';
import { getShopInfo } from '../modules/Auth/_redux/authCrud';

function useBranchOptions({ showAllActive = true, filterByCurrentBranch = false, includeHQ = true, HQLabel } = {}) {
  const shopBranches = useSelector(state => state.auth.shop?.branches) || [];
  const shopSeqId = useSelector(state => state.auth.shop?.seqId);
  const user = useSelector(state => state.auth.user);
  const intl = useIntl();
  const dispatch = useDispatch();

  const branches = shopBranches.filter(branch => {
    return (
      (!showAllActive || branch.isActive) &&
      (!filterByCurrentBranch || !user?.loggedInBranch || branch._id === user?.loggedInBranch?._id)
    );
  });

  const HQOption = { _id: '', name: HQLabel || intl.formatMessage({ id: 'branch.global' }) };
  const branchOptions = [...branches];

  if (includeHQ) {
    branchOptions.unshift(HQOption);
  }

  const refetchBranches = async () => {
    if (!shopSeqId) return;
    const res = await getShopInfo(shopSeqId);
    dispatch({ type: actionTypes.GetShopInfo, payload: res.data });
  };

  return {
    branches: branchOptions,
    refetchBranches
  };
}

export default useBranchOptions;
